import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { EASE, Eyebrow, Section } from './Shared';
import { faqs } from '../data/pack';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-105" data-mp="1cfjbu021gent">
      <div className="mb-10 text-center" data-id="element-106" data-mp="1ccdoap925ku7">
        <Eyebrow className="flex items-center justify-center gap-2" data-id="element-107" data-mp="2a2s0u51905uk">
          <HelpCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="2535r45kmp7qi" />
          Preguntas
        </Eyebrow>
        <h2 className="mt-3 font-title text-2xl leading-tight text-brand-jadeDeep md:text-4xl" data-id="element-109" data-mp="2042ikb5fwjds">
          Lo que más nos preguntan
        </h2>
        <div className="double-rule mx-auto mt-5 w-24" aria-hidden="true" data-id="element-110" data-mp="1v46fqf8haxzt" />
      </div>

      <div className="space-y-3" data-id="element-111" data-mp="op5r6uls9i39">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.q} className="paper-panel overflow-hidden border-l-4 border-l-brand-jade" data-id="element-112" data-mp="jo9fhuv6wrna" data-mpi={index}>
              <button type="button" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-rice focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-jade md:px-6" data-id="element-113" data-mp="1ko9ok0dcgg03">
                <span className="font-title text-sm text-brand-jadeDeep md:text-base" data-id="element-114" data-mp="1fqglvhb9244k">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-cinnabar transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-115" data-mp="11ve5g08s0wdi" />
              </button>
              <AnimatePresence initial={false} data-id="element-116" data-mp="rx88zy5qoig1">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: EASE
            }} data-id="element-117" data-mp="wyxgj3tr6dzd">
                    <p className="border-t border-brand-ink/10 bg-brand-rice px-5 py-4 font-serif text-sm leading-relaxed text-brand-inkLight md:px-6 md:text-base" data-id="element-118" data-mp="2kvwzgjc5dt5g">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}